import axios from 'axios';
/**
 * PageView - Set Page View
 * Event Tracking - Set all event tracking
 * These events are setup in GTM as well to pass the values to GA
 */
const GoogleAnalytics = {
	setPageView(path, title) {
		if (window && window.dataLayer) {
			return window.dataLayer.push({
				event: 'GAPageEvent',
				pagePath: path,
				pageTitle: title,
			});
		}
	},
	setEventTrackingGA4(event) {
		if (window && window.dataLayer && event) {
			return window.dataLayer.push({
				event,
			});
		}
	},
	setEventTracking(category, action, label) {
		if (window && window.dataLayer) {
			return window.dataLayer.push({
				event: 'GAevent',
				eventCategory: category,
				eventAction: action,
				eventLabel: label,
			});
		}
	},
	setOrderDataLayer(id) {
		axios
			.get(`/jsp/thirdparty/au/common/json_order_data_layer.jsp?orderId=${id}`)
			.then((res) => {
				if (window && window.dataLayer) {
					window.dataLayer.push(res.data);
					GoogleAnalytics.setOrderDataLayerGA4(id);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	},
	setOrderDataLayerGA4(id) {
		axios
			.get(
				`/jsp/thirdparty/au/common/json_order_data_layer_GA4.jsp?orderId=${id}`
			)
			.then((res) => {
				if (window && window.dataLayer) {
					window.dataLayer.push(res.data);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	},
};

export default GoogleAnalytics;
